// routes.js
import MainDashboard from 'views/admin/default';
import Configure from 'views/admin/configure';
import Interface from 'views/admin/interface';
import Logic from 'views/admin/logic';
import EditDevice from 'views/admin/editDevice';
// import TelemetryMonitor from 'views/admin/monitor';
import SignInCentered from 'views/auth/signIn';
import ModbusConfigs from 'views/admin/modbusConfigs/ModbusConfigs';
import Patches from 'views/admin/patches/Patches';
import SlaveConfigurations from 'views/admin/slaveConfigurations/SlaveConfigurations';
import AddConfiguration from 'views/admin/addConfiguration/AddConfiguration';
import PatchConfigurations from 'views/admin/patchConfigurations/PatchConfigurations';
import Logic2 from 'views/admin/logic/Logic2';
import Template from 'views/admin/site-templates/Templates';
import DeviceHealth from 'views/admin/deviceHealth/DeviceHealth';
import HealthCharts from 'views/admin/deviceHealth/HealthCharts';

export const routes = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: <MainDashboard />,
    layout: '/admin',
  },
  {
    name: 'Modbus Configs',
    path: '/modbus-configs',
    component: <ModbusConfigs />,
    layout: '/admin',
  },
  {
    name: 'Patches',
    path: '/patches',
    component: <Patches />,
    layout: '/admin',
  },
  {
    name: 'Templates',
    path: '/templates',
    component: <Template />,
    layout: '/admin',
  },
  {
    name: 'Slave Configurations',
    path: '/slave-configurations/:id',
    component: <SlaveConfigurations />,
    layout: '/admin',
  },
  {
    name: 'Patch Configurations',
    path: '/patch-configurations/:id',
    component: <PatchConfigurations />,
    layout: '/admin',
  },
  {
    name: 'Add Configurations',
    path: '/add-configuration',
    component: <AddConfiguration />,
    layout: '/admin',
  },
  {
    name: 'Add Configurations',
    path: '/add-new-patch',
    component: <Logic2 />,
    layout: '/admin',
  },
  {
    name: 'Configure Device',
    path: '/device/:deviceUUID/edit',
    component: <EditDevice />,
    layout: '/admin',
  },
  {
    name: 'Interfaces',
    path: '/device/:deviceUUID/interfaces',
    component: <Interface />,
    layout: '/admin',
  },
  {
    name: 'Configure',
    path: '/device/:deviceUUID/configure',
    component: <Configure />,
    layout: '/admin',
  },
  {
    name: 'Logic',
    path: '/logic',
    component: <Logic />,
    layout: '/admin',
  },

  {
    name: 'Sign In',
    path: '/sign-in',
    component: <SignInCentered />,
    layout: '/auth',
  },
  {
    name: 'Device Health',
    path: '/device-health',
    component: <DeviceHealth />,
    layout: '/admin',
  },
  {
    name: 'Health Details',
    path: '/health-details/:id',
    component: <HealthCharts />,
    layout: '/admin',
  },
  {
    name: 'Health Details',
    path: '/device/:deviceUUID/health-details',
    component: <HealthCharts />,
    layout: '/admin',
  },
];

export default routes;
